module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/code/node_modules/babel-loader/index.js?stage=0&optional=runtime!/code/src/scripts/chunks/stamp.js"));
    }, "stamp");
  });
}


/*****************
 ** WEBPACK FOOTER
 ** /code/~/promise-loader?global,stamp!./chunks/stamp.js
 ** module id = 1050
 ** module chunks = 0
 **/